module.exports = __webpack_public_path__ + "static/media/project-thumbnail07.0d07d9d3.jpg";